import { render, staticRenderFns } from "./OrderGlobalCard.vue?vue&type=template&id=20f9c417&scoped=true"
import script from "./OrderGlobalCard.vue?vue&type=script&lang=js"
export * from "./OrderGlobalCard.vue?vue&type=script&lang=js"
import style0 from "./OrderGlobalCard.vue?vue&type=style&index=0&id=20f9c417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9c417",
  null
  
)

export default component.exports